import {
  Cpu,
  Zap,
  Fuel,
  Thermometer,
  Wrench,
  LayoutGrid
} from "lucide-react";

export const categories = [
  { id: 1, label: "Engine", icon: Cpu },
  { id: 2, label: "Electrical", icon: Zap },
  { id: 3, label: "Fuel", icon: Fuel },
  { id: 4, label: "Cooling", icon: Thermometer },
  { id: 5, label: "Jet Pump", icon: Wrench },
  { id: 6, label: "Hull", icon: LayoutGrid }
];


export const trendingParts = [
  {
    id: 1,
    title: "GP1800 Wiring Harness",
    price: "654.99",
    image: "https://via.placeholder.com/300",
    delivery: "Fri, Apr 26 - Mon, Apr 29",
    fastest: "Apr 25"
  },
  {
    id: 2,
    title: "SVHO Fuel Pump",
    price: "229.99",
    image: "https://via.placeholder.com/300",
    delivery: "Fri, Apr 26 - Mon, Apr 29",
    fastest: "Apr 25"
  },
  {
    id: 3,
    title: "SuperJet ECU",
    price: "739.99",
    image: "https://via.placeholder.com/300",
    delivery: "Sat, Apr 27 - Tue, Apr 30",
    fastest: "Apr 26"
  },
  {
    id: 4,
    title: "Steering Cable",
    price: "189.99",
    image: "https://via.placeholder.com/300",
    delivery: "Fri, Apr 26 - Mon, Apr 29",
    fastest: "Apr 25"
  }
];

export const featuredParts = trendingParts;

export const models = [
  {
    id: 1,
    name: "Yamaha GP1800",
    years: "2018+",
    image: "https://via.placeholder.com/400"
  },
  {
    id: 2,
    name: "SeaDoo RXP 300",
    years: "2018+",
    image: "https://via.placeholder.com/400"
  },
  {
    id: 3,
    name: "FX SVHO",
    years: "2019+",
    image: "https://via.placeholder.com/400"
  },
  {
    id: 4,
    name: "Kawasaki Ultra",
    years: "2017+",
    image: "https://via.placeholder.com/400"
  }
];